import { Button, Grid } from '@mui/joy';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { endpoint } from '../../../resource/Constant';

export default function ShowDescription() {
  const [descriptions, setDescriptions] = useState();
  const [desLoading, setDesLoading] = useState(false);
  const descriptioColumn = [
    {
      field: 'id',
      headerName: 'id',
      sortable: false,
      flex: 1
    },
    {
      field: 'file_name',
      headerName: 'file_name',
      sortable: false,
      flex: 2
    },
    {
      field: 'position',
      headerName: 'Profile',
      sortable: false,
      flex: 2
    }
    // {
    //   field: 'Action',
    //   headerName: 'Action',
    //   sortable: false,
    //   flex: 2,
    //   renderCell: (ticket) => {
    //     return (
    //       <>
    //         <Grid container spacing={1}>
    //           <Button>open</Button>
    //         </Grid>
    //       </>
    //     );
    //   }
    // }
  ];

  const getallDescriptions = () => {
    setDesLoading(true);
    axios
      .post(`${endpoint}/api/aichatbot/description/getall`, null, {
        headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` }
      })
      .then((res) => {
        setDescriptions(res?.data);
        setDesLoading(false);
      })
      .catch((err) => {
        setDesLoading(false);
      });
  };
  useEffect(() => {
    getallDescriptions();
  }, []);
  return (
    <Grid container sx={{ height: '70vh', color: '#292929' }}>
      <Grid item sx={12} md={12}>
        <DataGrid
          columns={descriptioColumn}
          rows={descriptions}
          rowHeight={'50px'}
          rowCount={descriptions?.length}
          pageSizeOptions={[5]}
          paginationMode="server"
          paginationModel={{ page: 0, pageSize: 100 }}
          loading={desLoading}
          getRowHeight={() => 'auto'}
          sx={{
            height: '60vh',
            backgroundColor: '#3c3c3c',
            '& .MuiDataGrid-row': {
              // borderBottom: '1px solid white',
              color: '#FFFFFF',
              height: '50px',
              justifyContent: 'center',
              alignItems: 'center'
            },
            '&  .MuiDataGrid-columnHeader': {
              background: '#8abfc2',
              color: '#000000'
            },
            '&  .MuiTablePagination-root': {
              fontSize: '1.2rem',
              fontFamily: 'Arial, sans-serif',
              color: '#ffffff'
            }
          }}
        />
      </Grid>
    </Grid>
  );
}
